import styled from 'styled-components';
import colors from '../../colors';
import { styledWithProps } from '../../../util/styles';

type WindowWrapperProps = {
    zIndex: string;
};

export const WindowWrapper = styledWithProps<WindowWrapperProps>(styled.div)`
    position: fixed;
    overflow: hidden;
    padding: 10px;
    bottom: 20px;
    right: 20px;
    width: 400px;
    z-index: ${props => props.zIndex};
`;

export const Flex = styled.div`
    display: flex;
    margin-top: 0.5em;
`;

export const AvatarWrapper = styled.div`
    margin-right: 10px;
    img {
        width: 40px;
        height: 40px;
        max-width: none;
        max-height: none;
        border-radius: 50%;
        box-shadow: 0 1.5px 2.5px 0 rgba(0, 0, 0, 0.5);
    }
`;

export const TranscriptWrapper = styled.div`
    position: relative;
    overflow: hidden;
    background-color: ${colors.lightGray};
    border-radius: 5px;
    padding: 15px;
    width: 100%;
    box-shadow: 1px 3px 10px -1px rgba(0, 0, 0, 0.75);
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Proactive/Styles.tsx